import BuilderService from "../../Site/services/BuilderService";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { set } from "lodash";
import { initialAppState } from "../../Site/utils/jsonInitialData";
import {JsonBuilderServiceModel} from '../../Site/utils/Interfaces/jsonInterface';

function updateStateProperty(
  state: JsonBuilderServiceModel,
  path: string | string[],
  value: any
) {
  if (Array.isArray(path)) {
    path.forEach((p,index:number) => {
      set(state, p, value[index]);
    });
  } else {
    set(state, path, value);
  }
}


const builderServiceInstance = new BuilderService();
export const fetchApp: any = createAsyncThunk(
  "fetchApp",
  async (url: string) => {
    try {
      const response = await builderServiceInstance.fetchAppbyUrl(url);
      return response.data;
    } catch (error) {
      throw error;
    }
   
  }
);


 const jsonSlice = createSlice({
  name: "jsonObject",
  initialState: { data: initialAppState, savingStatus: false ,loading:false},
  reducers: {
    updateProperty: (
      state,
      action: PayloadAction<{ path: string | string[]; value: any }>
    ) => {
      const { path, value } = action.payload;
      updateStateProperty(state.data,path,value);
    },

    updateAndSaveProperty: (
      state,
      action: PayloadAction<{ path: string | string[]; value: any }>
    ) => {
      const { path, value } = action.payload;    
      state.savingStatus = true;
      updateStateProperty(state.data,path,value);
    },
    changeSavingStatus: (state, action: PayloadAction<boolean>) => {
      state.savingStatus = action.payload;
    },
    updateAppChangedStatus:(state, action: PayloadAction<boolean>)=>{
      state.data.changed=action.payload;
    },
    updateAllProperties:(state,action:PayloadAction<JsonBuilderServiceModel>)=>{
      state.data=action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApp.pending, (state) => {
        state.loading=true;
        return state;
      })
      .addCase(fetchApp.fulfilled, (state, action) => {
        state.loading=false;
        state.data = action.payload;
      })
      .addCase(fetchApp.rejected, (state) => {
        return state;
      });
  },
});


export default jsonSlice.reducer;
export const { updateProperty, updateAndSaveProperty ,changeSavingStatus,updateAppChangedStatus,updateAllProperties} = jsonSlice.actions;